import { isHttps, getScript } from '../utils'
import { mossoParams } from '../store/mosso'

// let mossp_pgvmain_params;

/**
 * 加载 mosso / tcss 组件脚本
 */
function getPttTcss(){
    return new Promise((resolve, reject) => {
        if (!window.PTTSendClick&&!window.pgvMain) {
            // let src = isHttps() ? '//ossweb-img.qq.com/images/js/PTT/ping_tcss_tgideas_https_min.js' : 
            // '//ossweb-img.qq.com/images/js/PTT/ping_tcss_tgideas_min.js'
            let src = '//ossweb-img.qq.com/images/js/PTT/ping_tcss_tgideas_https_min.js'
            getScript(src).then(()=>{
                // if(mossp_pgvmain_params) window.pgvMain(mossp_pgvmain_params)
                resolve()
            })
        } else {
            // if(mossp_pgvmain_params) window.pgvMain(mossp_pgvmain_params)
            resolve()
        }
    })
}


function reportToPtt( opts ) {
    opts.meta = opts.meta||{}
    getPttTcss().then(() => {
        let pageType = mossoParams.prefix + opts.name
        window.setSite = {
            siteType: mossoParams.siteType,
            pageType,
            pageName: opts.meta.pageName ? opts.meta.pageName  : pageType,
            project: mossoParams.project,
            osact: mossoParams.osact,
            stayTime: mossoParams.stayTime
        }
        let mossp_pgvmain_params = { repeatApplay: mossoParams.repeatApplay, virtualURL: opts.path, virtualDomain: mossoParams.virtualDomain}
        window.pgvMain(mossp_pgvmain_params)
    })
}

function reportPttClick( params1, params2, params3 ) {
    getPttTcss().then(() => {
        window.PTTSendClick(params1, params2, params3);
    })
}

export { getPttTcss, reportToPtt, reportPttClick }